import { useEntityAccounts } from '../../queries/use-coa';
import { useWorkpaperAccounts } from '../../queries/use-workpaper-accounts';
import AccountsMappingForm from './AccountsMappingForm';
import { Workpaper } from '../../types/workpaper';
import { Entity } from '../../types/entity';

type PreviewChartModalProps = {
    workpaper: Workpaper;
    entity: Entity;
    onMap: (data: { workpaperId: string; accountsConfirmed: number }) => void;
};

function WorkpaperAccountsMappingContainer({ workpaper, entity, onMap }: PreviewChartModalProps): JSX.Element {
    const chart = entity.charts.find((c) => c.provider?.toString() === workpaper.provider?.toString());

    const entityAccountsQuery = useEntityAccounts(entity.id, chart!.id);
    const workpaperAccountsQuery = useWorkpaperAccounts(workpaper.id);

    const isLoading = entityAccountsQuery.isLoading || workpaperAccountsQuery.isLoading;

    const accounts = (workpaperAccountsQuery.data?.accounts ?? []).sort((a, b) => ((a.code ?? '') > (b.code ?? '') ? 1 : -1));
    const entityAccounts = (entityAccountsQuery.data?.items ?? []).sort((a, b) => ((a.code ?? '') > (b.code ?? '') ? 1 : -1));

    return (
        <>
            <div className="flex items-start justify-between">
                <hgroup className={'text-left'}>
                    <h2 className="text-lg text-gray-900 font-medium">Link Accounts</h2>
                    <p className="text-sm text-gray-600 max-w-[100ch]">
                        Map existing accounts in the workpaper to the corresponding accounts in the entity&apos;s chart of accounts.
                        We&apos;ll attempt to auto match accounts by code and name. When you are happy with the mappings, click
                        &ldquo;Confirm&ldquo;.
                    </p>
                </hgroup>
            </div>

            <hr className="my-4" />
            <AccountsMappingForm
                workpaper={workpaper}
                entity={entity}
                accounts={accounts}
                entityAccounts={entityAccounts}
                isLoading={isLoading}
                chartProvider={chart?.provider}
                onMap={onMap}
            />
        </>
    );
}

export default WorkpaperAccountsMappingContainer;
